import { render } from "./AskFallbackView.vue?vue&type=template&id=414fc018&scoped=true"
import script from "./AskFallbackView.vue?vue&type=script&lang=js"
export * from "./AskFallbackView.vue?vue&type=script&lang=js"

import "./AskFallbackView.vue?vue&type=style&index=0&id=414fc018&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-414fc018"]])

export default __exports__